import { createRouter, createWebHistory } from 'vue-router';
import TestEip6963View from '../views/TestEIP6963View.vue';
import EbtcWithdrawView from "@/views/EbtcWithdrawView.vue";

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    { path: '/eip6963', name: 'TestEip6963', component: TestEip6963View },
    { path: '/ebtc-withdraw', name: 'EbtcWithdraw', component: EbtcWithdrawView },
  ],
});

export default router;
